export default __webpack_public_path__ + "static/media/D1996_08_18_Buenos_Aires.ddd79485.jpg";